import ReactDocumentTitle from "./ReactDocumentTitle";
import AppLayout from "../layouts/AppLayout";
import OldNavBar from "./navbar/OldNavBar";
import cn from "classnames";
import React from "react";
import {createUseStyles} from "react-jss";

type Props = {
  title: string;
  header: React.ReactNode;
}
export default function SettingsLayout({title, header, children}: React.PropsWithChildren<Props>) {
  const styles = legacyStyles();

  return (
    <>
      <AppLayout className={'bg-white'}>
        <ReactDocumentTitle title={title}/>
        <div className="flex flex-row pb-20">
          <OldNavBar/>
          <div className="pt-8 w-full pl-5 pr-40 mr-2">
            <div className={cn('flex flex-row justify-between border-b pb-4', styles.borderColor)}>
              {header}
            </div>
            <div className="py-6">
              {children}
            </div>
          </div>
        </div>
      </AppLayout>
    </>
  )
}

const legacyStyles = createUseStyles(
  {
    borderColor: {
      borderColor: '#e7e7e7'
    }
  }
);
